// @flow
import * as actionTypes from './actions';
import type { Action } from './actions';

import type { IContactInfo } from './IContactInfo';
import initialState from 'store/initialState';

function reducer(
  state: IContactInfo = initialState.appointment.contactInfo,
  action: Action
): IContactInfo {
  switch (action.type) {
    case actionTypes.SET_CONTACT_INFO: {
      return action.payload;
    }
    case actionTypes.SET_FIRST_NAME: {
      return { ...state, firstName: action.payload };
    }
    case actionTypes.SET_LAST_NAME: {
      return { ...state, lastName: action.payload };
    }
    case actionTypes.SET_PHONE: {
      return { ...state, phone: action.payload };
    }
    case actionTypes.SET_MOBILE_PHONE: {
      return { ...state, mobilePhone: action.payload };
    }
    case actionTypes.SET_EMAIL: {
      return { ...state, email: action.payload };
    }
    case actionTypes.SET_PERSON_ID: {
      return { ...state, id: action.payload };
    }
    case actionTypes.SET_EXT_ID: {
      return { ...state, extId: action.payload };
    }
    case actionTypes.SET_IS_OBFUSCATED: {
      return { ...state, obfuscatedBy: action.payload };
    }
    default:
      return state;
  }
}

export default reducer;



// WEBPACK FOOTER //
// ./src/store/reducers/appointment/contactInfo/reducer.js